var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"spinner-transition"},on:{"after-leave":_vm.removeStyle}},[_c('div',{staticClass:"spinner-fade"},[_c('b-spinner',{staticClass:"spinner",style:(_vm.spinnerStyle),attrs:{"variant":_vm.variant}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }